import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-add-clients',
    templateUrl: './add-clients.component.html',
    styleUrls: ['./add-clients.component.scss'],
    standalone: false
})
export class AddClientsComponent implements OnInit {
  public activeTheme: any;
  public createIndividual: boolean = false;
  public createAccount: boolean;

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ZpDataService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const createAccount = params['createAccount'] === 'true';
      console.log('createAccount:', createAccount);

      if (createAccount) {
        // Perform actions when createAccount is true
        console.log('createAccount is true');
        this.createAccount = true;
      } else {
        // Perform actions when createAccount is false
        console.log('createAccount is false');
        this.createAccount = false;
      }
    });
    this.activeTheme = this.themeService.active;
    this.api.getProfessionalInviteTemplate();
  }

  createIndividualClient() {
    if (this.createAccount == true) {
      this.router.navigate(["/invite-only"], { queryParams: { createAccount: true } });
    } else {
      this.router.navigate(["/invite-only"]);
    }
  }

  redirectToUploadList() {
    if (this.createAccount == true) {
      this.router.navigate(["/upload-professionals-list"], { queryParams: { createAccount: true }});
    } else {
      this.router.navigate(["/upload-professionals-list"], { queryParams: { createAccount: false }});
    }
  }
}
